import { render, staticRenderFns } from "./RosaGraf.vue?vue&type=template&id=1f790c68&scoped=true&"
import script from "./RosaGraf.vue?vue&type=script&lang=js&"
export * from "./RosaGraf.vue?vue&type=script&lang=js&"
import style0 from "./RosaGraf.vue?vue&type=style&index=0&id=1f790c68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f790c68",
  null
  
)

export default component.exports